export function isActive(action, actions, checkIns) {
    if (actions.some((other) => other.replacesId === action.id)) {
        return false;
    }
    return !checkIns.some((c) => c.actionId === action.id && (c.outcome === "stop" || c.outcome === "complete"));
}
export function currentCheckIn(action, checkIns) {
    const latest = checkIns
        .filter((c) => c.actionId === action.id && c.outcome === "continue")
        .reduce((best, c) => (best === null || new Date(c.createdAt).getTime() >= new Date(best.createdAt).getTime() ? c : best), null);
    return latest
        ? { on: latest.nextCheckInOn, channel: latest.nextCheckInChannel }
        : { on: action.checkInOn, channel: action.checkInChannel };
}
export function activeActions(actions, checkIns) {
    return actions
        .filter((a) => isActive(a, actions, checkIns))
        .map((a) => ({ action: a, on: currentCheckIn(a, checkIns).on }))
        .sort((a, b) => {
        if (a.on !== b.on) {
            if (a.on === null) {
                return 1;
            }
            if (b.on === null) {
                return -1;
            }
            return a.on < b.on ? -1 : 1;
        }
        return new Date(a.action.createdAt).getTime() - new Date(b.action.createdAt).getTime();
    })
        .map((x) => x.action);
}
const helsinkiDate = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Helsinki" });
// Visibility is filtered after "active", over all rows: an action changed
// into an internal-only successor leaves the client's view, because the
// clinician chose that for the current version.
export function clientPlanItems(actions, checkIns) {
    return activeActions(actions, checkIns)
        .filter((a) => a.clientVisible)
        .map((a) => {
        const checkIn = currentCheckIn(a, checkIns);
        return {
            id: a.id,
            kind: a.kind,
            title: a.title,
            instructions: a.instructions,
            runsForWeeks: a.runsForWeeks,
            startedOn: helsinkiDate.format(new Date(a.createdAt)),
            checkInOn: checkIn.on,
            checkInChannel: checkIn.channel,
            authorName: a.authorName,
            authorTitle: a.authorTitle,
        };
    });
}
